<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/n5cqPD/tc-custom/9781504097581.jpg?1737196287869" alt="This image is the cover for the book Red Harvest, The Continental Op"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Red Harvest, The Continental Op
      </h1>
      <p class="bookDescription body article font2">
        <b>From a crime writer and “an acknowledged literary landmark,” a PI heads west and battles corruption and a rising death toll in this 1920s classic mystery (<i>The </i><i>New York Times Book Review</i>).</b><br/>  <br/> Summoned to Personville, the detective known as Continental Op discovers the real reason locals call the western mining town “Poisonville.” The whole community has been divvied up into warring factions of gangsters and petty criminals. As the body count continues to rise, starting with the newspaperman who called in the detective for help, the Op decides to stick around. He is determined to clean up the criminal element, even if it means interrogating the whole town. But corruption knows no bounds and soon enough, the trusty detective finds himself a prime suspect of murder.<br/>  <br/> “Dashiell Hammett is an original. He is a master of the detective novel, yes, but also one hell of a writer.” —<i>The </i><i>Boston Globe</i><br/>  <br/> “Hammett’s prose [is] clean and entirely unique. His characters [are] as sharply and economically defined as any in American fiction.” —<i>The </i><i>New York Times</i><br/>  <br/> “[Hammett] was spare, frugal, hard-boiled, but he did over and over again what only the best writers can ever do at all. He wrote scenes that seemed never to have been written before.” —Raymond Chandler
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dashiell  Hammett
      </h2>
      
      <p class="authorDescription body article">Dashiell Hammett (18941961) was an American author of hard-boiled detective novels and short stories. He is widely regarded as one of the finest mystery writers of all time. In addition to The Maltese Falcon, his pioneering novels include Red Harvest, The Dain Curse, The Glass Key, and the #1 New York Times bestseller The Thin Man.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media/MysteriousPress.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a116bba